module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/bcf7608ed38d25025c86ad5e03a51bdc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_lock.svg
// module id = ytev
// module chunks = 0